module.exports = __webpack_public_path__ + "static/media/unavailable_pink.964c44d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/unavailable_pink.png
// module id = 2450
// module chunks = 0